import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, faqJsonLd, serviceJsonLd, webPageJsonLd } from "@/lib/seo";
import { FAQS_SHOPIFY_CRO } from "@/lib/service-content/faqs/shopify-cro";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/shopify-cro";

export const Route = createFileRoute("/shopify-cro")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "en",
    title: "Shopify CRO Agency: Evidence, Implementation & Testing · Shugert",
    description: "Shopify CRO for established brands: measurement review, friction diagnosis, native implementation and explicit decision rules. CRO & Technical SEO Fix from $3,000.",
    path: PATH,
    altPath: alternatePath(PATH, "es"),
    ogImage: "/og-cro-seo-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Shopify CRO", path: PATH }]),
      faqJsonLd(FAQS_SHOPIFY_CRO.en),
      serviceJsonLd({
        name: "Shopify Conversion Rate Optimization",
        description: "Evidence-led Shopify CRO connecting measurement, hypotheses, native implementation, QA and decision reporting.",
        path: PATH,
        serviceType: "Shopify CRO",
        minPrice: 3000,
        maxPrice: 5000,
        unit: "PROJECT",
        deliverables: ["Measurement review", "Friction map", "Prioritized hypotheses", "Native Shopify implementation", "Decision report"],
        locale: "en",
      }),
      webPageJsonLd({ name: "Shopify CRO Agency", path: PATH, description: "Evidence-led Shopify CRO with native implementation and explicit decision rules.", inLanguage: "en-US" }),
    ],
  }),
});
